<template>
    <div class="parametric-sort__list">
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    name: 'SortList',

    computed: {
        ...mapGetters({sort: 'GET_SORT'})
    }
};
</script>
